const ACCESS_TOKEN_KEY = 'cms_access_token';
const REFRESH_TOKEN_KEY = 'cms_refresh_token';
const USER_KEY = 'cms_user';
const USERNAME_KEY = 'cms_username';
const PERMISSIONS_KEY = 'cms_permissions';
const ROLES_KEY = 'cms_roles';

function getJson(key) {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function setJson(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value));
}

export const tokenStorage = {
  getAccessToken: () => sessionStorage.getItem(ACCESS_TOKEN_KEY),
  setAccessToken: (token) => sessionStorage.setItem(ACCESS_TOKEN_KEY, token),

  getRefreshToken: () => sessionStorage.getItem(REFRESH_TOKEN_KEY),
  setRefreshToken: (token) => sessionStorage.setItem(REFRESH_TOKEN_KEY, token),

  getUser: () => getJson(USER_KEY),
  setUser: (user) => setJson(USER_KEY, user),

  getUsername: () => sessionStorage.getItem(USERNAME_KEY),
  setUsername: (username) => sessionStorage.setItem(USERNAME_KEY, username),

  getPermissions: () => getJson(PERMISSIONS_KEY) || [],
  setPermissions: (permissions) => setJson(PERMISSIONS_KEY, permissions),

  getRoles: () => getJson(ROLES_KEY) || [],
  setRoles: (roles) => setJson(ROLES_KEY, roles),

  clear: () => {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
    sessionStorage.removeItem(USERNAME_KEY);
    sessionStorage.removeItem(PERMISSIONS_KEY);
    sessionStorage.removeItem(ROLES_KEY);
  },
};
